import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

// ----------------------------- o

import Login from '@/pages/Login'
import Index from '@/pages/Index'

// ----------------------------- o

import Intro from '@/pages/intro/Index'

// ----------------------------- o

import UserIndex from '@/pages/user/Index'
import UserEdit from '@/pages/user/Edit'
import UserDelete from '@/pages/user/Delete'
import UserSetPassword from '@/pages/user/SetPassword'
import UserNotifications from '@/pages/user/Notifications'

// ----------------------------- o

import ChallangeIndex from '@/pages/challenges/Index'

// ----------------------------- o

import ReportIndex from '@/pages/reports/Index'
import ReportKnowledgeIndex from '@/pages/reports-knowledge/Index'
import ReportSpecialsIndex from '@/pages/reports-specials/Index'
import InvitationsIndex from '@/pages/invitations/Index'
import InvitationsList from '@/pages/invitations/List'
import BalancesIndex from '@/pages/balances/Index'

// ----------------------------- o

import KnowledgeIndex from '@/pages/knowledge/Index'
import KnowledgeScore from '@/pages/knowledge/tabs/Score'
import KnowledgePill from '@/pages/knowledge/tabs/KnowledgePill'
import PillSingle from '@/pages/knowledge/pills/PillSingle'
import KnowledgeQuestions from '@/pages/knowledge/tabs/Questions'
import QuestionSingle from '@/pages/knowledge/questions/QuestionSingle'

// ----------------------------- o

import SpecialsList from '@/pages/specials/SpecialsList'
import SpecialsIndex from '@/pages/specials/Index'
import SpecialsSingle from '@/pages/specials/tabs/SpecialsSingle'
import SpecialsSummary from '@/pages/specials/tabs/SpecialsSummary'

// ----------------------------- o

import NewsIndex from '@/pages/news/Index'
import NewsList from '@/pages/news/tabs/News'
import KnowledgeZoneList from '@/pages/news/tabs/KnowledgeZone'
import NewsSingle from '@/pages/news/news/NewsSingle'
import KnowledgeZoneSingle from '@/pages/news/knowledge-zone/KnowledgeZoneSingle'

// ----------------------------- o

import CalendarIndex from '@/pages/calendar/Index'
import PrizesIndex from '@/pages/prizes/Index'
import RulesIndex from '@/pages/rules/Index'
import RegulationsIndex from '@/pages/regulations/Index'
import ContactIndex from '@/pages/contact/Index'

// ----------------------------- o

import Error403 from '@/pages/errors/Error403'
import Error404 from '@/pages/errors/Error404'

// ----------------------------- o

Vue.use(Router);

// ----------------------------- o

import Analytics from '@/services/Analytics';
import { Capacitor } from '@capacitor/core';
import Badge from '@/services/Badge';

let router = new Router({
    mode: 'hash',
    routes: [
        // Unauthenticated routes
        { path: '/', name: 'Index', component: Index },
        { path: '/login', name: 'Login', component: Login },
        { path: '/regulamin', name: 'RegulationsIndex', component: RegulationsIndex },

        // Authenticated routes
        { path: '/intro', name: 'Intro', component: Intro, meta: { auth: true, roles: ['user1', 'user2', 'user3'] }},
        { path: '/konto', name: 'UserIndex', component: UserIndex, meta: { auth: true, roles: ['user1', 'user2', 'user3','salesman'] }},
        { path: '/edytuj-dane', name: 'UserEdit', component: UserEdit, meta: { auth: true, roles: ['user1', 'user2', 'user3', 'salesman'] }},
        { path: '/usun-konto', name: 'UserDelete', component: UserDelete, meta: { auth: true, roles: ['user1', 'user2', 'user3', 'salesman'] }},
        { path: '/ustaw-haslo', name: 'UserSetPassword', component: UserSetPassword, meta: { auth: true, roles: ['user1', 'user2', 'user3', 'salesman'] }},
        { path: '/powiadomienia', name: 'UserNotifications', component: UserNotifications, meta: { auth: true, roles: ['user1', 'user2', 'user3', 'salesman'] }},

        {
            path: '/wyzwania',
            name: 'ChallangeIndex',
            component: ChallangeIndex,
            meta: { auth: true, roles: ['user1','user3'] },
            children: [
                // { path: '', redirect: { name: 'ChallengesMonthly' }},
                { path: 'miesieczne', name: 'ChallengesMonthly', meta: { auth: true, roles: ['user1','user3']} },
                { path: 'kwartalne', name: 'ChallengesQuarterly', meta: { auth: true, roles: ['user1','user3']} },
                { path: 'osiagniecia', name: 'ChallengesSummary', meta: { auth: true, roles: ['user1','user3']} },
            ],
        },

        { path: '/raporty', name: 'ReportIndex', component: ReportIndex, meta: { auth: true, roles: ['salesman'] }},
        { path: '/raporty-wiedza', name: 'ReportKnowledgeIndex', component: ReportKnowledgeIndex, meta: { auth: true, roles: ['salesman'] }},
        { path: '/raporty-zadania-specjalne', name: 'ReportSpecialsIndex', component: ReportSpecialsIndex, meta: { auth: true, roles: ['salesman'] }},
        { path: '/zaproszenia', name: 'InvitationsIndex', component: InvitationsIndex, meta: { auth: true, roles: ['salesman'] }},
        { path: '/zaproszenia-lista', name: 'InvitationsList', component: InvitationsList, meta: { auth: true, roles: ['salesman'] }},
        { path: '/rozliczenia', name: 'BalancesIndex', component: BalancesIndex, meta: { auth: true, roles: ['salesman'] }},

        {
            path: '/wiedza',
            name: 'KnowledgeIndex',
            component: KnowledgeIndex,
            meta : { auth: true, roles: ['user1', 'user2', 'user3', 'salesman']},
            children: [
                // { path: '', redirect: { name: 'KnowledgeScore' }},
                { path : 'wynik', name : 'KnowledgeScore', component: KnowledgeScore, meta : { auth: true, roles: ['user1', 'user2', 'user3', 'salesman']}},
                { path : 'pigulki-wiedzy', name : 'KnowledgePill', component: KnowledgePill, meta : { auth: true, roles: ['user1', 'user2', 'user3', 'salesman']}},
                { path : 'pigulki-wiedzy/:slug', name : 'PillSingle', component: PillSingle, props: true, meta : { auth: true, roles: ['user1', 'user2', 'user3', 'salesman']} },
                { path : 'pytania', name : 'KnowledgeQuestions', component: KnowledgeQuestions , meta : { auth: true, roles: ['user1', 'user2', 'user3', 'salesman']}},
                { path : 'pytanie/:slug', name : 'QuestionSingle', component: QuestionSingle, props: true, meta : { auth: true, roles: ['user1', 'user2', 'user3', 'salesman']}},
                // { path : 'pigulki-wiedzy/:slug/pytanie/:questionSlug', name : 'KnowledgeQuestions', component: QuestionSingle, props: true, meta : { auth: true, roles: ['user1', 'user2', 'user3',]}}
            ]
        },

        {
            path: '/zadania-specjalne',
            name: 'SpecialsIndex',
            component: SpecialsList,
            meta: {auth: true, roles: ['user1', 'user2', 'user3']}
        },

        {
            path: '/zadania-specjalne/',
            name: 'SpecialsTabs',
            component: SpecialsIndex,
            props: true,
            meta: { auth: true, roles: ['user1', 'user2', 'user3'] },
            children: [
                { path : ':slug', name : 'SpecialsSingle', component: SpecialsSingle, props: true, meta : { auth: true, roles: ['user1', 'user2', 'user3']}},
                { path : ':slug/podsumowanie', name : 'SpecialsSummary', component: SpecialsSummary, props: true, meta : { auth: true, roles: ['user1', 'user2', 'user3']}}
            ]
        },

        { path: '/news',
            name: 'NewsIndex',
            component: NewsIndex,
            meta: { auth: true, roles: ['user1', 'user2', 'user3', 'salesman']},
            children: [
                { path : 'aktualnosci', name : 'NewsList', component: NewsList, meta : { auth: true, roles: ['user1', 'user2', 'user3', 'salesman']}},
            ]
        },

        { path : 'strefa-wiedzy', name : 'KnowledgeZoneList', component: KnowledgeZoneList, meta : { auth: true, roles: ['user1', 'user2', 'user3', 'salesman']}},

        { path: '/news/:slug', name: 'NewsSingle', component: NewsSingle, props: true, meta: { auth: true, roles: ['user1', 'user2', 'user3', 'salesman'] }},
        { path: '/strefa-wiedzy/:slug', name: 'KnowledgeZoneSingle', component: KnowledgeZoneSingle, props: true, meta: { auth: true, roles: ['user1', 'user2', 'user3', 'salesman'] }},

        { path: '/kalendarz', name: 'CalendarIndex', component: CalendarIndex, meta: { auth: true, roles: ['user1', 'user3', 'salesman'] }},
        { path: '/nagrody', name: 'PrizesIndex', component: PrizesIndex, meta: { auth: true, roles: ['user1', 'user3', 'salesman'] }},
        { path: '/zasady', name: 'RulesIndex', component: RulesIndex, meta: { auth: true, roles: ['user1', 'user3', 'salesman'] }},
        { path: '/kontakt', name: 'ContactIndex', component: ContactIndex, meta: { auth: true, roles: ['user1', 'user2', 'user3', 'salesman'] }},

        // Error routes
        { path: '/403', name: "Error403", component: Error403 },
        { path: '/*', name: "Error404", component: Error404 }
    ]
});

// ----------------------------- o

router.beforeEach(async (to, from, next) => {

    if (Capacitor.platform !== 'web') {
        Analytics.logEvent({name: "page_view", params: {'page': to.path}})
    }

    // ---------

    if(to.matched.some(record => record.meta.auth)) {
        /*
            USER IS UNAUTHENTICATED
         */

        if(!store.getters.isAuthenticated) {
            console.log("%c user is unauthenticated!", 'background: #ff0000; color: #fff');
            // clear badge
            Badge.clearBadge()
            //
            next({name: 'Login'})
        }
        /*
            USER IS AUTHENTICATED
         */
        if(store.getters.isAuthenticated){
            console.log('%c user is authenticated', 'background: #00b000; color: #fff');

            // USER LOST HIS ROLE
            if(store.getters.getRole === null){
                console.log('%c lost user role!', 'background: #ff0000; color: #fff');
                return next({name: 'Index'})
            }

            /*
                ROUTE ROLE MATCHES USER ROLE
              */
            if(to.meta.roles.includes(store.getters.getRole)) {
                console.log('%c route matches to role', 'background: #0000ff; color: #fff');

                next();

                // console.log('hasChangedPassword:', store.getters.hasChangedPassword)
                if(store.getters.hasChangedPassword === false){
                    next({name: 'UserSetPassword'})
                }

            }else{
                console.log("%c 403", 'background: #ff0000; color: #fff');
                next({name: 'Error403'})
            }
        }
    }else{
        console.log('%c exit route ', 'background: #ffa500; color: #fff');
        // clear badge
        Badge.clearBadge()
        //
        next()
    }
});

export default router
